
















































































































































































































































































import Vue from 'vue'

export default Vue.extend({
    name: 'Window',
    metaInfo: {
        title: 'Window and Door Protection',
        meta : [
            {
                name: 'description',
                content : 'Window and Door Protection'
            },
            {
                name: 'keywords',
                content : 'window, door, maintenance, damage investigations, tie-down chain, retrofitting, cyclone, weather, storm, protection'
            }
        ]
    },


    data: () => ({

    }),
    computed: {

    },
})
